
import component1           from '@/components/stat/Sales.vue'
import component2           from '@/components/gchart/gchart1.vue'
import component3           from '@/components/stat/KPI.vue'
import component4           from '@/components/stat/PaymentRunningTotal.vue'

import component5           from '@/components/stat/ShopAssistantSales.vue'
import component6           from '@/components/stat/TimeSlotSales.vue'
//import component6           from '@/components/stat/SoldTimeTable.vue'
import component7          from '@/components/stat/SellOutBySize.vue'
import component8          from '@/components/stat/BirthOfDayCalendar.vue'

const menuId = 'rp3'

const routes = [
    
 
    {
        path        : '/report3/sales',
        name        : 'sales',
        component   : component1,
        meta        : { name : 'Vendite retail/online', visible : true ,icon : 'fas fa-donate',menu:menuId,color:'brown'},

    },

    {
        path        : '/report3/sales_yeartoyear',
        name        : 'salesYearToYear',
        component   : component2,
        meta        : { name : 'Vendite anno su anno', visible : true ,icon : '	fas fa-poll',menu:menuId,color:'blue'},
        
    },    

    {
        path        : '/report3/kpi_retail',
        name        : 'kpi_retail',
        component   : component3,
        meta        : { name : 'KPI Retail', visible : true ,icon : 'fas fa-cash-register',menu:menuId,color:'orange'},

    },
    
    {
        path        : '/report3/total_running',
        name        : 'total_running',
        component   : component4,
        meta        : { name : 'Running Total Cassa', visible : true ,icon : 'fas fa-infinity',menu:menuId,color:'#663399'},

    },
    {
        path        : '/report3/shop_assistant_sales',
        name        : 'shop_assistant_sales',
        component   : component5,
        meta        : { name : 'Vendite shopping assistant', visible : true ,icon : 'fas fa-user-tag',menu:menuId,color:'#DA70D6'},

    },
    {
        path        : '/report3/time_sales',
        name        : 'time_sales',
        component   : component6,
        meta        : { name : 'Vendite in fascia oraria', visible : true ,icon : 'far fa-clock',menu:menuId,color:'red'},


    },
    {
        path        : '/report3/sold_by_size',
        name        : 'soldBySize',
        component   : component7,
        meta        : { name : 'Immesso/venduto per Misura', visible : true ,icon : 'fas fa-balance-scale',menu:menuId,color:'violet',divider:1},
        divider     : 1

    },
    
    {
        path        : '/report3/customer_birthday',
        name        : 'customer_birthday',
        component   : component8,
        meta        : { name : 'Compleanno clienti', visible : true ,icon : 'far fa-calendar-alt',menu:menuId,color:'red'},

    },

        
]
export default routes